module.exports = __webpack_public_path__ + "static/img/equ2.1ca6e036.jpg";